import { Type } from '@dipscope/type-manager';
import { NodeDef } from '../tilebase/TileGameConfig';
import { Place, Shape } from './KTile';

export interface KNodeDef {
  id: number;
  type: string;
  x: number;
  y: number;
  conns: number[];
  cities?: number[];
  roads?: number[];
  wald?: number[];
  mine?: boolean;
}

@Type({
  injectable: true
})
export class KNodeDefClass implements KNodeDef {
  id: number;
  type: string;
  x: number;
  y: number;
  conns: number[] = [];
  cities?: number[] = [];
  roads?: number[] = [];
  wald?: number[] = [];
  mine?: boolean;
}

export interface KTileDef {
  type: number;
  count?: number;
  sides: string;
  nodes: Array<KNodeDef>;
  rot?: number;
  shape: Shape;
  place?: Place;
}

@Type({
  injectable: true
})
export class KTileDefClass implements KTileDef {
  type: number;
  count?: number;
  sides: string;
  nodes: Array<KNodeDef>;
  rot?: number;
  shape: Shape;
  place?: Place;
}
